/* eslint-disable max-len */
import React, { useState, useEffect, useCallback } from 'react';
import { Config } from '@leverege/plugin';
import { TextInput, Dialog, Pane, Flex, Text, Button } from '@leverege/ui-elements';
import I18N from '@leverege/i18n';
import S from './ImageEditor.css';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const {
  t
} = I18N.ns('molten.imagine.forms.editors.ImageEditor');
const opts = {
  table: {
    isRenderer: true,
    blockChildren: false
  },
  detail: {
    isRenderer: true,
    blockChildren: false
  }
};
export default {
  valueType: 'image',
  getOptions: usage => {
    return Config.get('ImageEditor', usage, opts[usage]);
  },
  create: opts => {
    const {
      attribute,
      children,
      context,
      editable,
      eventData,
      object,
      onChange,
      usage,
      value,
      key,
      dataEditable,
      ...options
    } = opts;
    const delegate = context?.clientProps?.delegate;
    if (!editable) {
      return children;
    }
    return /*#__PURE__*/_jsx(ImageToggle, {
      usage: usage,
      delegate: delegate,
      attr: attribute,
      eventData: eventData,
      target: object,
      value: value,
      onChange: onChange,
      ...options
    }, key);
  }
};
function ImageToggle(props) {
  const {
    usage,
    attr: attribute
  } = props;
  const [opened, setOpened] = useState(false);
  const onClose = useCallback(() => {
    setOpened(false);
  }, []);
  if (usage === 'table' || usage === 'detail') {
    if (opened) {
      const titleText = attribute.source.attribute.getString('titleDialogImage', `Edit ${attribute.displayName}`);
      return /*#__PURE__*/_jsx(Dialog, {
        variant: "attributeEditorDialog|dialog",
        show: opened,
        onClose: onClose,
        title: /*#__PURE__*/_jsxs(Flex, {
          variant: "rowSpaceBetween",
          children: [/*#__PURE__*/_jsx(Text, {
            variant: "dialogTitle",
            children: titleText
          }), /*#__PURE__*/_jsx(Button, {
            variant: "closeDialog",
            onClick: onClose
          })]
        }),
        children: /*#__PURE__*/_jsx(ImageEditor, {
          ...props,
          onClose: onClose
        })
      });
    }
    return /*#__PURE__*/_jsx(Button, {
      variant: "editImage",
      onClick: () => {
        setOpened(true);
      }
    });
  }
  return /*#__PURE__*/_jsx(ImageEditor, {
    ...props
  });
}
function ImageEditor(props) {
  const {
    attr,
    eventData,
    value,
    onChange: pOnChange,
    disabled
  } = props;
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(false);
  const hint = attr?.blueprint?.attribute?.getTagStartingWith('hint:', true) || t('hint');
  useEffect(() => {
    if (value) {
      setLoading(true);
      const img = new Image();
      img.src = value;
      if (img.complete) {
        setLoading(false);
      } else {
        img.onload = () => {
          setLoading(false);
        };
        img.onerror = () => {
          setError('We can\'t find or access the image at that URL. Please check again.');
          setLoading(false);
        };
      }
    }
  }, [value]);
  const onChange = useCallback(evt => {
    setError(null);
    pOnChange(evt);
  }, [pOnChange]);
  return /*#__PURE__*/_jsxs(Pane, {
    layout: "flex:colS",
    children: [/*#__PURE__*/_jsx(TextInput, {
      value: value,
      disabled: disabled,
      eventData: eventData,
      hint: hint,
      alwaysFireOnReturn: true,
      changeOnBlur: true,
      alwaysFireOnBlur: true,
      variant: "imageUrlInput",
      maxLength: 1000,
      onChange: onChange
    }), value && !loading && !error && /*#__PURE__*/_jsxs(Flex, {
      variant: "colS",
      children: [/*#__PURE__*/_jsx(Text, {
        variant: "captionSmallBold",
        children: "Image Preview"
      }), /*#__PURE__*/_jsx("img", {
        src: value,
        alt: "",
        className: S.image
      })]
    }), error && /*#__PURE__*/_jsx(Text, {
      variant: "inputCaptionSmallError",
      children: error
    })]
  });
}